module.exports = __webpack_public_path__ + "img/PL08876.0bfdf82d.png";